export default [
  {
    id: 1,
    name: "Guru Gobind Singh Indraprastha University",
    major: "Computer Science",
    degree: "B.Tech",
    dated: "2015 - 2019",
    cgpa: "9",
  },
]
